import React from "react"
import { AccordionItem, AccordionItemBody, AccordionItemTitle } from "react-accessible-accordion"

import TranslatedText from "../../TranslatedText"
import {__} from "../../../services/i18n"

const ShortAndLongTermEffectsAccordionItem = () => (
    <AccordionItem>
        <AccordionItemTitle>
            <h3>{__('procedure_mastectomy:accordion_5_1_heading')}</h3>
        </AccordionItemTitle>
        <AccordionItemBody>
            <p><TranslatedText translationKey="procedure_mastectomy:accordion_5_1_paragraph_1" /></p>
            <p><TranslatedText translationKey="procedure_mastectomy:accordion_5_1_paragraph_2" /></p>
            <p><TranslatedText translationKey="procedure_mastectomy:accordion_5_1_paragraph_3" /></p>
            <p><TranslatedText translationKey="procedure_mastectomy:accordion_5_1_paragraph_4" /></p>
        </AccordionItemBody>
    </AccordionItem>
)

export default ShortAndLongTermEffectsAccordionItem
